/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectsListQueryResponse, ProjectsListQueryParams } from "../models/ProjectsList";

export function getProjectsListUrl() {
  const res = { method: 'GET', url: `/projects` as const }  
  return res
}

/**
 * @summary List projects for the client (optionally by source type and id)
 * {@link /projects}
 */
export async function projectsList(params?: ProjectsListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectsListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getProjectsListUrl().url.toString(), params, ... requestConfig })  
  return res.data
}